import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
    connect() {
        if (!this.element) return

        this.swiper = new Swiper(this.element, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: {
                enabled: true,
                momentum: true,
                momentumRatio: 0.5,
            },
            loop: true,
            loopAdditionalSlides: 4,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            speed: 6000,
            grabCursor: true,
            allowTouchMove: true,
        })

        // Listen for resume events from parent
        this.boundResumeHandler = this.handleResume.bind(this)
        window.addEventListener('prompts-swiper:resume', this.boundResumeHandler)
    }

    disconnect() {
        window.removeEventListener('prompts-swiper:resume', this.boundResumeHandler)
        if (this.swiper) {
            this.swiper.destroy()
        }
    }

    handleResume() {
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.start()
        }
    }

    pause() {
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.stop()
        }
    }

    resume() {
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.start()
        }
    }
}
